import { render, staticRenderFns } from "./configLayoutFieldNameTemplate.vue?vue&type=template&id=2927860f&scoped=true"
import script from "./configLayoutFieldNameTemplate.vue?vue&type=script&lang=js"
export * from "./configLayoutFieldNameTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927860f",
  null
  
)

export default component.exports